import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Answer, Question, QuestionDAO } from '@org/interfaces';
import { environment } from '@org/shared-services';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class QandaService {
  private apiUrl = `${environment.apiUrl}/api/question`;

  constructor(private http: HttpClient){}

  getQuestions(userId: string): Observable<Question[]> {
    return this.http.get<Question[]>(`${this.apiUrl}/query/manager/${userId}`);
  }

  getTenantTechs(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/tenant/tech-users`);
  }

  getTechUserQuestions(userId: string): Observable<Question[]> {
    return this.http.get<Question[]>(`${this.apiUrl}/query/user/${userId}`);
  }

  addQuestion(question: QuestionDAO): Observable<any> {
    return this.http.post(`${this.apiUrl}/register`, question);
  }

  updateQuestion(question: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/`, question);
  }

  deleteQuestion(questionId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${questionId}`);
  }

  addAnswer(answer: Answer): Observable<any> {
    return this.http.put(`${this.apiUrl}/answer/add`, answer);
  }
}
